import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ScenaAccesso, useScenaAccesso } from '../components/accesso/ScenaAccesso';
import { TestaCard } from '../components/accesso/campi';
import { useTraduzioniOspite } from '../utils/linguaOspite';

// Indirizzo che non esiste (link vecchio o sbagliato): una pagina che lo dice e riporta alla propria area,
// nella stessa scena del login. Prima restava una pagina completamente vuota.
const DOVE = { admin: '/admin', collaboratore: '/collaboratore', cliente: '/dashboard' };

const NonTrovata = () => {
  const { userType } = useAuth();
  const { t } = useTraduzioniOspite();
  const scena = useScenaAccesso('MK Client — Pagina non trovata');
  const casa = DOVE[userType] || '/login';
  return (
    <ScenaAccesso scena={scena}>
      <TestaCard etichetta={t('accesso.non_trovata_etichetta')} titolo={t('accesso.non_trovata_titolo')}
        corsivo={t('accesso.non_trovata_corsivo')} sotto={t('accesso.non_trovata_sotto')} />
      <div className="body" data-testid="pagina-non-trovata">
        <Link className="btn" to={casa} replace>
          <span>{t(userType ? 'accesso.non_trovata_torna' : 'accesso.non_trovata_accesso')}</span>
        </Link>
      </div>
    </ScenaAccesso>
  );
};

export default NonTrovata;
